import clientSay1 from "images/client1.png";
import clientSay4 from "images/client2.png";
import clientSay5 from "images/client3.png";
import clientSay6 from "images/client4.png";

export const globalJson = {
  prod_company_id: 451,
  dev_company_id: 451,

  // apiUtil auth header key
  authToken: "Bearer 168|3oLFn8OniSxk1UBTO3eQeGXMuViDTsZqAwhalwWm",
  companyId: "7514a219-48ce-439e-a2c5-6f38980cee1a",
  stripePublishableKey:
    "pk_live_51LdnoABqYa4ICTHoC6CjEgImHYOvUXXPs8psg8jZqXPxRwBt99nQEWtFFJj2n3ublkCJa0S8pYzDtvStF2JxUPzU00uWCskvlb",
  mapKey: "AIzaSyDKEntg7JydrxI7zr2tQL5OYcS5M-er-bc",
  residenceStateCode: "AZ",

  //email confirmation admin token
  adminEmailToken:
    "XR85jFku2zMMqvsYmAdkrk1lm6pozj7eFXetRHLNSSsLxRLnAHgY3dPaVsE27OK8cIbnhFQmncWxVjS1XLAhneFEFpwVVeaNE7hMOym2vrhzdKSmxn99V0fLvVJyZLPT",
  websiteLink: "https://LA Exotic Autos-dev.1now.app",
  sender: "LA Exotic Autos",
  ccEmail: "LA Exotic Autos@gmail.com",

  // apiUtil sendNewsLetterEmail
  util_serviceId: "service_2xca7kj",
  util_templateId: "template_smckeo7",
  util_userId: "ATdsFr5wumje11YkV",
  util_privateKey: "TJyyV_e7nNOGPKbyyjpMB",
  util_contact_templateId: "template_9dsuz0w",

  // apiUtil getBonzahToken
  client_secret_dev: "",
  client_id_dev: "",
  client_secret_prod: "",
  client_id_prod: "",

  about_us_para:
    "At LA Exotic Autos, we’re redefining the car rental experience with a modern, reliable, and customer-first approach. Whether you're a local commuter, a business traveler, or a tourist exploring the city, our fleet of well-maintained, fuel-efficient vehicles ensures a smooth journey every time.",

  clientSays_arr: [
    {
      id: 1,
      clientName: "A'Lissia B.",
      clientAddress: "Dodge Grand Caravan 2019",
      content:
        "The car was awesome. I booked at the last minute and the car was perfect!",
      img: clientSay1,
    },
    {
      id: 2,
      clientName: "Deshailyn P.",
      clientAddress: "LondDodge Grand Caravan 2019",
      content: "the car was great & very clean will rent again for sure !!",
      img: clientSay4,
    },
    {
      id: 3,
      clientName: "Mancel C.",
      clientAddress: "Dodge Grand Caravan 2019",
      content: "Car was top tier clean, host communicated well",
      img: clientSay5,
    },
  ],

  //social links
  facebook: "https://www.facebook.com/",
  instagram:
    "https://www.instagram.com/",

  //contact
  address: "N/A",
  operating_time: "09:00 am - 7:00 pm",
  addressLink:
    "https://www.google.com/maps/place/4830+W+Kennedy+Blvd,+Tampa,+FL+33609,+USA/data=!4m2!3m1!1s0x88c2c2e4b61fbe87:0x7fa31f86943d0895?sa=X&ved=1t:242&ictx=111",
  phone: "N/A",
  email: "N/A",
  company_name: "LA Exotic Autos",
};

export const scriptHubSpot = document.createElement("script");
scriptHubSpot.src = "//js-na1.hs-scripts.com/46776911.js";
scriptHubSpot.async = true;
scriptHubSpot.defer = true;
scriptHubSpot.id = "hs-script-loader";
